import React from 'react'
import styled from 'styled-components'
import logo from 'assets/images/bp-logo.png'
import { useSelector } from 'react-redux'
import { getCurrentUser, isUserLoggedIn } from 'features/auth/ducks/selectors'
import { PATHS, PRIVATE_PATHS, redirect } from 'utils/paths'

const ExternalLayout = ({ children }) => {
  const isLoggedIn = useSelector(isUserLoggedIn)
  const currentUser = useSelector(getCurrentUser)

  const handleLoginClick = () => {
    redirect(PATHS.login)
  }

  const handleSignupClick = () => {
    redirect(PATHS.signup)
  }

  const handleDashboardClick = () => {
    redirect(
      ['emergency_service', 'responsible_person'].includes(currentUser?.type)
        ? PRIVATE_PATHS.bpList
        : PRIVATE_PATHS.dashboard
    )
  }

  return (
    <Wrapper>
      <Header>
        <Logo src={logo} alt="Logo" onClick={() => redirect('/')} />

        <RightSection>
          {isLoggedIn ? (
            <HeaderLink onClick={handleDashboardClick}>Dashboard</HeaderLink>
          ) : (
            <>
              <HeaderLink onClick={handleLoginClick}>Login</HeaderLink>
              <HeaderLink onClick={handleSignupClick}>Sign Up</HeaderLink>
            </>
          )}
        </RightSection>
      </Header>

      <Content>{children}</Content>
    </Wrapper>
  )
}

export default ExternalLayout

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.backgroundColor || '#f9f9f9'};
`

const Header = styled.header`
  padding: 20px 40px;
  background: white;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

const HeaderLink = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.haiti};
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

const Content = styled.main`
  flex: 1;
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`
